import { UIDiv } from '@ui';

/**
 * Skeleton loader for the project grid view
 * Shows placeholder cards while projects are loading
 */
export default class ProjectGridSkeleton extends UIDiv {
  constructor({ itemCount = 8 } = {}) {
    super();
    this.itemCount = itemCount;
    this.setId('project-grid-skeleton');
    this.setClass('flex flex-wrap justify-center gap-4 p-4');

    this.#render();
  }

  #render() {
    for (let i = 0; i < this.itemCount; i++) {
      const card = this.#createCardSkeleton(i);
      this.add(card);
    }
  }

  #createCardSkeleton(index) {
    const card = new UIDiv();
    card.setClass(
      'flex flex-col grow w-full h-[350px] box-border shadow-lg rounded-[var(--N4)] m-2.5 min-w-[300px] max-w-[400px] border border-gray-200 overflow-hidden',
    );

    // Thumbnail skeleton
    const thumbnailContainer = new UIDiv();
    thumbnailContainer.setClass('w-full h-[200px] bg-gray-200 animate-pulse');
    card.add(thumbnailContainer);

    // Content area
    const content = new UIDiv();
    content.setClass('p-4 space-y-3');

    // Title skeleton
    const titleWidth = ['w-3/4', 'w-2/3', 'w-4/5', 'w-1/2'][index % 4];
    const title = new UIDiv();
    title.setClass(`${titleWidth} h-5 bg-gray-200 rounded animate-pulse`);
    content.add(title);

    // Subtitle/description skeleton
    const subtitle = new UIDiv();
    subtitle.setClass('w-1/2 h-3 bg-gray-200 rounded animate-pulse');
    content.add(subtitle);

    // Meta info row
    const metaRow = new UIDiv();
    metaRow.setClass('flex items-center gap-2 pt-2');

    const date = new UIDiv();
    date.setClass('w-20 h-3 bg-gray-200 rounded animate-pulse');
    metaRow.add(date);

    const spacer = new UIDiv();
    spacer.setClass('flex-1');
    metaRow.add(spacer);

    const avatar = new UIDiv();
    avatar.setClass('w-6 h-6 bg-gray-200 rounded-full animate-pulse');
    metaRow.add(avatar);

    content.add(metaRow);
    card.add(content);

    return card;
  }
}
